import { NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FreeBackgroundComponent } from './free-background-landing/free-background.component';
import { FreeBackgroundAuthComponent } from './free-background-auth/free-background-auth.component';
import { CampaignComponent } from './campaign.component';


const routes: Routes = [
  {
    path: '', component: CampaignComponent,
    children: [
      { path: 'free-background', component: FreeBackgroundComponent },
      { path: 'free-background/auth/:token', component: FreeBackgroundAuthComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignRoutingModule { }
